import React from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";

const Support = ({ handleShow }) => {
  return (
    <div>
      <div
        className="leftContainer mb_space"
        style={{ minHeight: "100vh", height: "100%" }}
      >
        <div className="help-center-page">

      <div className="help-banner">
        <div className="help-banner-inner">
          <img
            src="/images/support-agent.png"
            alt=""
            className="help-agent"
          />

          <h2>HELP CENTER</h2>
          <p>We're here to help you 24/7</p>
        </div>
      </div>

      <h5 className="support-title">
        CHOOSE SUPPORT CHANNEL
      </h5>

      <div className="support-grid">

        {JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport && (
          <a href={JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport}    target="_blank"
            rel="noreferrer"  className="support-card whatsapp-card" >
            <div className="support-icon whatsapp-icon">
              <img  src="/images/whatsapp.png"   alt=""  />
            </div>
            <span>WHATSAPP</span>
          </a>
        )}

        <a href={JSON.parse(localStorage.getItem("sitSetting"))?.telegramSupport}    target="_blank"   rel="noreferrer"
          className="support-card telegram-card"   >
          <div className="support-icon telegram-icon">
            <img src="/images/tel.png"  alt="" />
          </div>
          <span>TELEGRAM</span>
        </a>
      </div>

  <a
    href={
      "tel:" +
      JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
    }
    className="helpline-card"
  >
    <div className="helpline-icon">
      <img
        src="/images/phone.png"
        alt=""
      />
    </div>

    <div className="helpline-content">
      <h4>OFFICIAL HELPLINE</h4>
      <p>
        <span className="status-dot"></span>
        SYSTEM ACTIVE
      </p>
    </div>
  </a>

</div>



      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
